import { FormattedMessage } from 'react-intl';
import { Outlet } from 'react-router-dom';

import Tab from 'src/registry/components/navigation/Tab';
import TabRow from 'src/registry/components/navigation/TabRow';
import { billingPoliciesMessages } from 'src/features/servicePlanBillingPolicies/utils/messages';
import { pricingPoliciesMessages } from 'src/features/servicePlanPricingPolicies/utils/messages';
import { ServicePlanItemTabContext } from 'src/features/servicePlanItems/utils/tabContext';

type ServicePlanItemDashboardTablesProps = {
    isServicePlanItemActive?: boolean;
};

const ServicePlanItemDashboardTables = ({ isServicePlanItemActive }: ServicePlanItemDashboardTablesProps) => {
    return (
        <div className="grid flex-3 grid-cols-1">
            <TabRow>
                <Tab to="billing-policies" preventScrollReset>
                    <FormattedMessage {...billingPoliciesMessages.billingPolicies} />
                </Tab>
                <Tab to="pricing-policies" preventScrollReset>
                    <FormattedMessage {...pricingPoliciesMessages.pricingPolicies} />
                </Tab>
            </TabRow>
            <div className="mt-4">
                <Outlet context={{ isServicePlanItemActive } satisfies ServicePlanItemTabContext} />
            </div>
        </div>
    );
};

export default ServicePlanItemDashboardTables;
